import type { TransitDashboardSummary } from "../../hooks/react-query/linehaul/useTransitDashboardSummary";

// Mock data matches actual API response structure
// Using 'import type' to avoid enum dependencies in Playwright tests (esbuild strip-only mode)
export const mockTransitDashboardSummary = {
  default: {
    totalActiveTrips: 124,
    onTimeTrips: 97,
    atRiskTrips: 22,
    lateTrips: 5,
  },
} as const satisfies Record<string, TransitDashboardSummary>;
